"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackProductAdded = trackProductAdded;
exports.trackProductListViewed = trackProductListViewed;
exports.default = exports.trackRegistryItemAdded = exports.trackProductDismissed = exports.trackProductClicked = exports.trackProductViewed = exports.trackProduct = void 0;

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.function.name.js");

var _productHelper = require("../../util/productHelper");

var _trackingHelper = require("../trackingHelper");

/*
  This file contains events from the Zola Web Analytics tracking plan related to shop products:
  'Product Added': https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=164175519
*/
function trackProductAdded(eventData) {
  if (!eventData) {
    // eslint-disable-next-line no-console
    console.warn('Product Added event called with falsy value.');
    return;
  }

  if (Object.keys(eventData).length === 0) // eslint-disable-next-line no-console
    console.warn('Product Added event called without properties.'); // if the brand is not defined - clear it on the GTM data layer becuase we check for it to determine if the product added is a cash gift.

  if (!eventData.brand && window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push({
      brand: undefined
    });
  }

  (0, _trackingHelper.trackEvent)('Product Added', eventData);
}

function trackProductListViewed(_ref) {
  var products = _ref.products,
      location = _ref.location,
      section = _ref.section;
  var productsTrackingData = products.map(function (product, index) {
    var _getFormattedProductP = (0, _productHelper.getFormattedProductProperties)(product),
        product_id = _getFormattedProductP.product_id,
        sku = _getFormattedProductP.sku,
        category = _getFormattedProductP.category,
        name = _getFormattedProductP.name,
        brand = _getFormattedProductP.brand,
        variant = _getFormattedProductP.variant,
        price = _getFormattedProductP.price,
        quantity = _getFormattedProductP.quantity,
        url = _getFormattedProductP.url,
        image_url = _getFormattedProductP.image_url;

    return {
      product_id: product_id,
      sku_id: sku,
      category: category,
      name: name,
      brand: brand,
      variant: variant,
      price: price,
      quantity: quantity,
      position: index + 1,
      url: url,
      image_url: image_url
    };
  });
  var trackingData = {
    location: location,
    section: section,
    products: productsTrackingData
  };
  (0, _trackingHelper.trackEvent)('Product List Viewed', trackingData);
}

var trackProduct = function trackProduct(eventType, _ref2) {
  var product = _ref2.product,
      position = _ref2.position,
      location = _ref2.location,
      section = _ref2.section,
      registry_id = _ref2.registry_id,
      recommendation_source = _ref2.recommendation_source,
      endpoint_variant = _ref2.endpoint_variant;

  var _getFormattedProductP2 = (0, _productHelper.getFormattedProductProperties)(product),
      product_id = _getFormattedProductP2.product_id,
      sku = _getFormattedProductP2.sku,
      category = _getFormattedProductP2.category,
      name = _getFormattedProductP2.name,
      brand = _getFormattedProductP2.brand,
      variant = _getFormattedProductP2.variant,
      price = _getFormattedProductP2.price,
      quantity = _getFormattedProductP2.quantity,
      url = _getFormattedProductP2.url,
      image_url = _getFormattedProductP2.image_url;

  var payload = {
    registry_id: eventType === 'Clicked' ? registry_id : undefined,
    product_id: product_id,
    sku: sku,
    category: category,
    name: name,
    brand: brand,
    variant: variant,
    price: price,
    quantity: quantity,
    position: position,
    url: url,
    image_url: image_url,
    location: location,
    section: section,
    recommendation_source: recommendation_source,
    endpoint_variant: endpoint_variant
  };
  (0, _trackingHelper.trackEvent)("Product ".concat(eventType), payload);
};

exports.trackProduct = trackProduct;

var trackProductViewed = function trackProductViewed(eventProps) {
  trackProduct('Viewed', eventProps);
};

exports.trackProductViewed = trackProductViewed;

var trackProductClicked = function trackProductClicked(eventProps) {
  trackProduct('Clicked', eventProps);
};

exports.trackProductClicked = trackProductClicked;

var trackProductDismissed = function trackProductDismissed(eventProps) {
  trackProduct('Dismissed', eventProps);
}; // TODO: Add additional eventProps as needed.

/**
 * https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1421749706
 */


exports.trackProductDismissed = trackProductDismissed;

var trackRegistryItemAdded = function trackRegistryItemAdded(_ref3) {
  var product = _ref3.product,
      location = _ref3.location,
      section = _ref3.section,
      recommendation_source = _ref3.recommendation_source,
      endpoint_variant = _ref3.endpoint_variant;

  var _getFormattedProductP3 = (0, _productHelper.getFormattedProductProperties)(product),
      sku = _getFormattedProductP3.sku,
      name = _getFormattedProductP3.name,
      brand = _getFormattedProductP3.brand,
      price = _getFormattedProductP3.price,
      quantity = _getFormattedProductP3.quantity,
      image_url = _getFormattedProductP3.image_url;

  (0, _trackingHelper.trackEvent)('Registry Item Added', {
    sku: sku,
    name: name,
    brand: brand,
    price: price,
    quantity: quantity,
    image_url: image_url,
    location: location,
    section: section,
    recommendation_source: recommendation_source,
    endpoint_variant: endpoint_variant
  });
};

exports.trackRegistryItemAdded = trackRegistryItemAdded;
var _default = {
  trackProductAdded: trackProductAdded,
  trackProductListViewed: trackProductListViewed,
  trackProduct: trackProduct,
  trackProductViewed: trackProductViewed
};
exports.default = _default;